import {Scenario} from "../../../types";
import {PlayerReduxState} from "../types";

export default function getCurrentScenario(state: PlayerReduxState): Scenario {
  return state.scenarios[state.scenarioIndex];
}
